import { Stethoscope, HeartPulse, Wallet } from "lucide-react";

export const PLATFORMS = [
  {
    slug: "prosthoai",
    name: "ProsthoAI",
    icon: Stethoscope,
    variant: "prostho",
    href: "https://prosthoai.com",
    tagline: "Specialist-grade clinical decision support for dental professionals.",
    summary:
      "ProsthoAI brings 30 years of prosthodontic reasoning to every operatory. From treatment planning to case acceptance, it supports the clinical decisions that define quality dentistry.",
    features: [
      { t: "Treatment Planning", d: "Structured, evidence-informed plans for single crowns through full-mouth rehabilitation." },
      { t: "Case Acceptance", d: "Clear patient-facing narratives that help patients understand and accept care." },
      { t: "Clinical Documentation", d: "Documentation prompts aligned with radiographic evidence standards." },
      { t: "Smile Showcase", d: "Visual case presentation tools for consultations." },
      { t: "Prosthodontic Rules", d: "Decision rules codified from specialist experience and ACP-aligned standards." },
      { t: "Revenue Awareness", d: "Documentation quality signals that reduce downstream claim friction." },
    ],
    audience: "Dentists, prosthodontists, and dental teams",
  },
  {
    slug: "zidamd",
    name: "ZidaMD",
    icon: HeartPulse,
    variant: "zida",
    href: "https://zidamd.com",
    tagline: "Advanced clinical reasoning support for physicians and medical practices.",
    summary:
      "ZidaMD supports physician reasoning with structured differentials, current coding fluency, and risk calculators — decision support that respects the physician's final judgment.",
    features: [
      { t: "Clinical Reasoning", d: "Structured differential support with visible reasoning traces." },
      { t: "ICD-10 2026 Fluency", d: "Current coding awareness built into every workflow." },
      { t: "Risk Calculators", d: "Validated calculators surfaced in context." },
      { t: "Physician Feedback Loop", d: "The system learns from clinician corrections." },
      { t: "Decision Support, Not Diagnosis", d: "Outputs are labelled as support — the physician always decides." },
      { t: "Cross-Specialty Knowledge", d: "Insight shared across the CamelionAI ecosystem." },
    ],
    audience: "Physicians and medical practices",
  },
  {
    slug: "reimbursepro",
    name: "ReimbursePro",
    icon: Wallet,
    variant: "reimburse",
    href: "https://reimburse.pro",
    tagline: "AI-powered medical and dental billing, prior auth, and claims appeals.",
    summary:
      "ReimbursePro turns denial patterns into prevention. It drafts claims, prepares prior authorisations, and builds appeals — with human review preserved at every step.",
    features: [
      { t: "Claims Drafting", d: "Clean-claim preparation informed by payer behaviour patterns." },
      { t: "Prior Authorisation", d: "Structured prior-auth preparation with evidence checklists." },
      { t: "Appeals Builder", d: "Denial-specific appeal letters grounded in documentation." },
      { t: "Denial Pattern Library", d: "Institutional memory of what payers deny — and why." },
      { t: "CDT ↔ CPT Bridge", d: "Cross-coding support for medical-dental workflows." },
      { t: "Patient Portal", d: "Clear patient-facing billing communication." },
    ],
    audience: "Billing teams, practice managers, and providers",
  },
];

export const INQUIRY_TYPES = [
  { k: "beta", label: "Beta access" },
  { k: "partnership", label: "Partnership" },
  { k: "investment", label: "Investment" },
  { k: "professional", label: "Professional inquiry" },
  { k: "media", label: "Media" },
  { k: "general", label: "General" },
];
